import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { useRouter } from 'next/router'
import {
    Heart,
    Search,
    Sparkles,
    KeyRound
} from 'lucide-react'

import { cn } from '@/lib/utils'
import { useSavedHomes } from '@/hooks/use-saved-homes'

const tabs = [
    { href: '/homes', label: 'Explore', icon: Search },
    { href: '/style-match', label: 'Style match', icon: Sparkles },
    { href: '/saved', label: 'Saved', icon: Heart },
    { href: '/sell', label: 'Sell', icon: KeyRound }
]

export const MobileTabBar: FC = (): ReactNode => {
    const router = useRouter()
    const { ids, ready } = useSavedHomes()

    return (
        <nav
            aria-label='Quick links'
            className='fixed inset-x-0 bottom-0 z-40 border-t border-border bg-white/95 pb-[env(safe-area-inset-bottom)] backdrop-blur md:hidden'
        >
            <ul className='mx-auto grid max-w-md grid-cols-4'>
                {tabs.map(tab => {
                    const active = router.pathname === tab.href || (tab.href === '/homes' && router.pathname.startsWith('/homes'))
                    const Icon = tab.icon

                    return (
                        <li key={tab.href}>
                            <Link
                                href={tab.href}
                                aria-current={active ? 'page' : undefined}
                                className={cn(
                                    'relative flex flex-col items-center gap-1 py-2.5 text-[0.7rem] font-semibold transition',
                                    active ? 'text-primary' : 'text-muted-foreground'
                                )}
                            >
                                <Icon className='size-6' strokeWidth={active ? 2.25 : 1.75} aria-hidden='true' />
                                {tab.label}
                                {tab.href === '/saved' && ready && ids.length > 0 && (
                                    <span className='absolute top-1.5 left-1/2 ml-2 min-w-4 rounded-full bg-primary px-1 text-center text-[0.6rem] leading-4 font-bold text-white'>
                                        {ids.length}
                                    </span>
                                )}
                            </Link>
                        </li>
                    )
                })}
            </ul>
        </nav>
    )
}
